(function ($) {
	class Block_Video extends BD_Block {
		constructor() {
			super();

			this.type = "video";
			this.templateID = "video-template";

			this.elms = {
				playBtn: ".js-play",
				pauseBtn: ".js-pause",
				questionCard: ".questionCard",
				answer: ".js-answer",
				submit: ".js-submit",
				video: "#js-fullscreen-video",
				backWrapper: ".questionCard__back",
				back: ".js-back",
			};

			this._events = this.getEvents();

			/* custom attributes */
			this.video = false;
		}

		getEvents() {
			const elms = this.elms;
			return [
				{
					event: "click",
					selector: elms.playBtn,
					handler: this.onPlayVideo,
				},
				{
					event: "click",
					selector: elms.pauseBtn,
					handler: this.onPauseVideo,
				},
				{
					event: "click",
					selector: elms.submit,
					handler: this.submit,
				},
				{
					event: "click",
					selector: elms.back,
					handler: this.back,
				},
			];
		}

		beforeinit() {
			this.render();
			this.setupVideo();
			this.setGameState();
			this.setQuestion();
			this.setTimer();
		}

		render() {
			const htmlTemplate = $("#" + this.templateID).html();
			let template = Handlebars.compile(htmlTemplate);

			const videoFromVariable = BD_Variable.getVideoFromVariable(this._data)
			this._data.video = videoFromVariable || this._data.video

			const html = template(this._data);
			$("#templateWrapper").html(html);
		}

		setupVideo() {
			const _this = this;
			const $elVideo = $(_this.elms.video);

			if ($elVideo.length < 0) {
				return false;
			}

			const $questionCard = $(_this.elms.questionCard);

			_this.video = videojs($elVideo.attr("id"), {
				controls: true,
				autoplay: false,
				preload: "auto",
			});

			_this.video.ready(function () {
				//set default style of subtitle
				const settings = this.textTrackSettings;

				settings.setValues({
					backgroundOpacity: "0",
					edgeStyle: "dropshadow",
				});

				settings.updateDisplay();

				const startPlayPromise = _this.video.play();

				if (startPlayPromise !== undefined) {
					startPlayPromise
						.then(() => {
							// Start whatever you need to do only after playback
							// has begun.
							$questionCard.addClass("videoPlaying");
						})
						.catch((error) => {
							console.log("Unable to start auto play", error);
						});
				}
			});

			_this.video.on("ended", function () {
				if (!_this._data.has_question) {
					BD_GAME_LOGIC.goToDefaultNextBlock();
					return false;
				}
				if (_this.video.isFullscreen()) {
					_this.video.exitFullscreen();
				}
				$questionCard.removeClass("videoPlaying");
				$questionCard.addClass("is-opened");
				_this.timer.start();

				_this.question.showSubmitBtn(_this);
			});

			_this.video.on("play", function () {
				$questionCard.addClass("videoPlaying");
			});
		}

		setGameState() {
			const showBackBtn = () => {
				if(BD_SequenceHistory.data) {
					$(this.elms.backWrapper).addClass('is-active')
				}
			}

			showBackBtn()
		}

		setQuestion() {
			this.question = BD_Question.create(this._data.question)
			this._events = [...this._events, ...this.question.getEvents()];
		}

		setTimer() {
			this.timer = new BD_Timer(this._data, this.question);
		}

		/* ========= ELEMENT FUNCTION HANDLER ===============*/
		onPlayVideo(e) {
			if (e) e.preventDefault();
			const _this = this;

			const $questionCard = $(_this.elms.questionCard);

			_this.video
				.play()
				.then(() => {
					$questionCard.addClass("videoPlaying");
					if (
						$questionCard.width() < 1024 ||
						$questionCard.hasClass("is-slider")
					)
						$questionCard.removeClass("is-opened");
				})
				.catch((error) => {
					// Autoplay was blocked. Do something
					console.log("Unable to start auto play", error);
				});
		}

		onPauseVideo(e) {
			if (e) e.preventDefault();
			const _this = this;
			const $questionCard = $(_this.elms.questionCard);

			if (!_this.video.paused()) {
				_this.video.pause();
				$questionCard.removeClass("videoPlaying");
			}
		}

		back(e) {
			const seqHistory = BD_SequenceHistory.data;
			const currentBlockID = parseInt(BD_GAME_LOGIC.getCurrentBlockID())
			const history = seqHistory[currentBlockID]
			if(!history) return

			BD_GAME_LOGIC.goBack(history.prev)
		}

		submit(e, $el) {
			this.question.submitAnswer($el, this);
		}

		beforeDestroy() {
			this.timer.stop();
			if (this.video) {
				this.video.dispose();
			}
		}
	}

	return new Block_Video();
})(jQuery);
